<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";

/**
 * Contacts-list component
 */
export default {
      page: {
            title: "Years List",
            meta: [{ name: "description", content: appConfig.description }]
      },
      components: { Layout, PageHeader },
      data() {
            return {
                  gridData: [],
                  title: "Year Report",
                  model: "Year",
                  items: [
                        {
                              text: "Dashboard",
                              href: "/dashboard"
                        },
                        {
                              text: 'Years List',
                              href: "/years/list"
                        },
                        {
                              text: 'Report',
                              active: true
                        }
                  ],
                  isLoadingGetList: false,
                  isLoadingPost: false,
                  token: null,
                  error_messages: [],
                  list_error_messages: [],
                  id: null,
                  name: null,
                  hide_cards: [],
                  showFilterOptions: true,
                  filter: {
                        user_id: 0,
                        room_id: 0,
                        subject_id: 0,
                        item_id: 0
                  },
                  userList: [],
                  roomList: [],
                  subjectList: [],
                  itemList: []
            };
      },
      validations: {
            selected_data: {
                  name: { required }
            },
      },
      async mounted(){
    
            this.token = await localStorage.getItem('authToken')
            this.id = this.$route.params.id;
            this.name = this.$route.query.name;

            if(!this.id || !this.name){
                  this.$router.push({ name: 'Year List' })
            }

            this.title = this.name + ' Report';

            this.getRoomList();
            this.getSubjectList();
            this.getItemList();
            this.getUserList()
      },
      methods: {
            getItemList(){
            //fetch data from API
                  axios.get(process.env.VUE_APP_API + '/public/item')
                  .then(res => {
                        this.itemList = res.data.data;

                        this.itemList.unshift({
                              id: 0,
                              name: 'Select All Items'
                        });
                  })
            },
            getSubjectList(){
                  //fetch data from API
                  axios.get(process.env.VUE_APP_API + '/public/subject')
                  .then(res => {
                        this.subjectList = res.data.data;

                        this.subjectList.unshift({
                              id: 0,
                              name: 'Select All Subjects'
                        });
                  })
            },
            getRoomList(){
                  //fetch data from API
                  axios.get(process.env.VUE_APP_API + '/room/getIndex', {
                        headers: {
                              Authorization: 'Bearer ' + this.token
                        }
                  })
                  .then(res => {
                        this.roomList = res.data.data;

                        this.roomList.unshift({
                              id: 0,
                              name: 'Select All Rooms'
                        });
                  })
            },
            getUserList(){
                  //fetch data from API
                  axios.get(process.env.VUE_APP_API + '/public/user', {
                        headers: {
                        Authorization: 'Bearer ' + this.token
                        }
                  })
                  .then(res => {
                        this.userList = res.data.data;

                        this.userList.unshift({
                              id: 0,
                              name: 'Select All Users'
                        });
                  })
            },
            getList(){
                  this.isLoadingGetList = true;

                  let filter = '?filter=1';
                  if(this.filter.user_id > 0){
                        filter += '&user_id=' + this.filter.user_id;
                  }
                  if(this.filter.room_id > 0){
                        filter += '&room_id=' + this.filter.room_id;
                  }
                  if(this.filter.subject_id > 0){
                        filter += '&subject_id=' + this.filter.subject_id;
                  }
                  if(this.filter.item_id > 0){
                        filter += '&item_id=' + this.filter.item_id;
                  }

                  //fetch data from API
                  axios.get(process.env.VUE_APP_API + '/year/' + this.id + filter, {
                        headers: {
                        'Authorization': 'Bearer ' + this.token
                        }
                  })
                  .then(res => {
                        this.gridData = res.data.data;
                  })
                  .catch(err => {
                        this.err = err;
                  })
                  .finally(() => {
                        this.isLoadingGetList = false;
                  });
            },
            renderBadgeColor(count){
                  if(count < 1) { return 'bg-danger'; }
                  if(count < 10) { return 'bg-dark'; }
                  if(count < 15) { return 'bg-success'; }
            },
            onClickCard(index){
                  if(this.hide_cards.includes(index)){
                        this.hide_cards = this.hide_cards.filter(item => item !== index);
                  }else{
                        this.hide_cards.push(index);
                  }
            },
            checkIfHide(index){
                  return this.hide_cards.includes(index);
            },
      
      }
};
</script>

<template>
      <Layout>
            <PageHeader :title="title" :items="items" />
            <div class="row">
                  <div class="col-lg-12">
                        <div class="card">
                              <div class="card-body">
                                    <div class="pt-3 mb-3 bg-light py-2 row">
                                          <div class="col-sm col-md-6 mb-1">
                                                <select
                                                      id="inputRoom"
                                                      v-model="filter.user_id"
                                                      class="form-control">
                                                      <option :value="user.id" v-for="(user, index) in userList" :key="`user_${index}`">{{user.name}}</option>
                                                </select>
                                          </div>
                                          <div class="col-sm col-md-6 mb-1">
                                                <select
                                                      id="inputRoom"
                                                      v-model="filter.room_id"
                                                      class="form-control">
                                                      <option :value="room.id" v-for="(room, index) in roomList" :key="`room_${index}`">{{room.name}}</option>
                                                </select>
                                          </div>
                                          <div class="col-sm col-md-6 mb-1">
                                                <select
                                                      id="inputSubject"
                                                      v-model="filter.subject_id"
                                                      class="form-control">
                                                      <option :value="subject.id" v-for="(subject, index) in subjectList" :key="`subject_${index}`">{{subject.name}}</option>
                                                </select>
                                          </div>
                                          <div class="col-sm col-md-6 mb-1">
                                                <select
                                                      id="inputItem"
                                                      v-model="filter.item_id"
                                                      class="form-control">
                                                      <option :value="item.id" v-for="(item, index) in itemList" :key="`item_${index}`">{{item.name}}</option>
                                                </select>
                                          </div>
                                          <div class="col-12 mt-3">
                                                <div class="text-center">
                                                      <b-button @click="getList()" variant="primary">Click to Filter Report</b-button>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div class="card" v-if="list_error_messages.length">
                              <div class="card-body">
                                    <div class="col">
                                          <b-alert show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                                          {{ err }}
                                          </b-alert>
                                    </div>
                              </div>
                        </div>
                        <div v-if="isLoadingGetList">
                              <div class="card">
                                    <div class="card-body">
                                          <p class="card-text placeholder-glow">
                                                <span class="placeholder col-11"></span>
                                          </p>
                                    </div>
                              </div>
                              <div class="card">
                                    <div class="card-body">
                                          <p class="card-text placeholder-glow">
                                                <span class="placeholder col-11"></span>
                                          </p>
                                    </div>
                              </div>
                        </div>

                        <div v-if="!isLoadingGetList" class="row">
                              <div class="col-md-12" v-for="(post, index) in gridData" :key="`post_${index}`">
                                    <div class="card">
                                          <div class="card-body pointer" @click="onClickCard(index)">
                                                <div>
                                                      <h5 class="d-inline">{{ index }}</h5>
                                                      <i class="fas fa-angle-down float-end font-size-24" v-if="!checkIfHide(index)"></i>
                                                      <i class="fas fa-angle-up float-end font-size-24" v-if="checkIfHide(index)"></i>
                                                </div>
                                                <hr v-if="!checkIfHide(index)" />
                                                <div class="row" v-if="!checkIfHide(index)">
                                                      <div class="col-lg-4 col-md-6 mb-3" v-for="(subject, index2) in post" :key="`subject_${index2}`">
                                                            {{ index2 }}
                                                            <div class="col">
                                                                  <span :class="`badge even-larger-badge me-1 ${renderBadgeColor(item.post_count)}`" v-for="(item, index3) in subject" :key="`item_${index3}`">
                                                                        {{ item.post_count }} {{ item.item_name }}
                                                                  </span>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      </Layout>
</template>